export const ColorServicePlugin = {
  install(Vue) {
    Vue.prototype.$colorService = new ColorService();
  }
};

export default class ColorService {
  constructor() {
    this.colors = [
      "#1f77b4",
      "#ff7f0e",
      "#2ca02c",
      "#d62728",
      "#9467bd",
      "#8c564b",
      "#e377c2",
      "#bcbd22",
      "#17becf",
      "#7f7f7f"
    ];

    this.colorAssignments = new Map();
  }

  /**
   * Returns the mapped color if the element has been mapped before, else returns a new color and saves the mapping.
   * @param id {String|number}Key of the element.
   * @returns {String} the Hex Code of the assigned color.
   */
  getColorById(id = this.isRequired()) {
    if (!this.colorAssignments.has(id)) {
      this.colorAssignments.set(id, this._getFirstUnusedColor());
    }
    return this.colorAssignments.get(id);
  }

  /**
   * Removes a single element->color mapping. Used after deselection.
   * @param id {String|number} Key of the element.
   * @returns {boolean} Returns `true` if an element had a color assigned and has been removed, or `false` if the element does not exist.
   */
  removeColorById(id = this.isRequired()) {
    return this.colorAssignments.delete(id);
  }

  /**
   * Removes all element->color mappings. Used after selection mode switch to reset the coloring.
   */
  clear() {
    this.colorAssignments.clear();
  }

  isRequired = () => {
    throw new Error("param is required");
  };

  _getFirstUnusedColor() {
    const usedColors = Array.from(this.colorAssignments.values());
    for (const c of this.colors) {
      if (!usedColors.includes(c)) {
        return c;
      }
    }
    return this.colors[this.colors.length - 1];
  }
}
